module.exports = require("xtpoints");


//////////////////
// WEBPACK FOOTER
// external "xtpoints"
// module id = 49
// module chunks = 0